import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  html {
    background-color: #f9f9f9;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    min-height: 100vh;
    scroll-behavior: smooth;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    width: 100%;
    margin: 0;
    padding: 0;
    overflow: overlay;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
    font-family: Larsseit, sans-serif;
    color: #161345;
  }

  body .tl-edges {
    overflow-x: unset;
  }

  main,
  section,
  div {
    margin: 0;
    padding: 0;
  }

  a {
    text-decoration: none;
    &:focus {
      color: inherit;
    }
  }

  img {
    max-width: 100%;
    object-fit: contain;
    position: relative;
    margin: 0;
    padding: 0;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
    font-weight: normal;
    text-rendering: optimizeLegibility;
  }

  p {
    padding: 0;
    margin: 0 0 1rem 0;
    font-weight: normal;
    text-rendering: optimizeLegibility;
  }
`

export default GlobalStyle
